import React from "react";

const Index = () => {
  return (
    <section className="text-center text-xl lg:pt-36 ">
      <p className="text-center">Select a Country</p>
    </section>
  )
}

export default Index